export function waitForOrderCusFirebase(maxMs = 8000): Promise<NonNullable<Window['OrderCusFirebase']>> {
  return new Promise((resolve, reject) => {
    const start = Date.now()
    const tick = () => {
      if (window.OrderCusFirebase) {
        resolve(window.OrderCusFirebase)
        return
      }
      if (Date.now() - start > maxMs) {
        reject(new Error('OrderCusFirebase ไม่พร้อม — ตรวจสอบการโหลด Firebase SDK'))
        return
      }
      requestAnimationFrame(tick)
    }
    tick()
  })
}

let firebaseApiPromise: Promise<NonNullable<Window['OrderCusFirebase']>> | null = null

export async function getFirebase() {
  if (!firebaseApiPromise) {
    firebaseApiPromise = (async () => {
      const fb = await waitForOrderCusFirebase()
      await fb.init()
      return fb
    })().catch((error) => {
      firebaseApiPromise = null
      throw error
    })
  }
  return firebaseApiPromise
}
